<template lang="pug">
  v-layout(row)
    v-menu(
      ref="dateMenu"
      lazy
      :close-on-content-click="false"
      v-model="dateMenu"
      transition="scale-transition"
      offset-y
      full-width
      :nudge-right="40"
      max-width="290px"
      min-width="290px"
      :return-value.sync="date"
    )
      v-text-field(
        box
        slot="activator"
        :label="$options.computed.formatString(type, 'date')"
        v-model="date"
        prepend-icon="event"
        readonly
      )
      v-date-picker(
        v-model="date"
        no-title
        scrollable
      )
        v-spacer
        v-btn(
          flat
          color="primary"
          @click="dateMenu = false"
        ) Cancel
        v-btn(
          flat
          color="primary"
          @click="$refs.dateMenu.save(date)"
        ) OK
    //- v-flex(xs6)
    //-   v-menu(
    //-     ref="timeMenu"
    //-     lazy
    //-     :close-on-content-click="false"
    //-     v-model="timeMenu"
    //-     transition="scale-transition"
    //-     offset-y
    //-     full-width
    //-     :nudge-right="40"
    //-     max-width="290px"
    //-     min-width="290px"
    //-     :return-value.sync="time"
    //-     disabled
    //-   )
    //-     v-text-field(
    //-       slot="activator"
    //-       :label="$options.computed.formatString(type, 'time')"
    //-       v-model="time"
    //-       prepend-icon="access_time"
    //-       readonly
    //-       disabled
    //-     )
    //-     v-time-picker(
    //-       v-model="time"
    //-       @change="$refs.timeMenu.save(time)"
    //-     )
</template>

<script>
export default {
  name: 'datetime',
  props: [
    'name', 'initialDate', 'initialTime', 'type'
  ],
  data () {
    return {
      date: this.initialDate,
      time: this.initialTime,
      dateMenu: false,
      timeMenu: false
    }
  },
  computed: {
    formatString: function (type, str) {
      return `${type} ${str}`
    }
  },
  watch: {
    date: function (newDate, oldDate) {
      this.$emit('dateChange', {'type': this.type, 'date': newDate})
    },
    time: function (newTime, oldTime) {
      this.$emit('timeChange', {'type': this.type, 'time': newTime})
    }
  }
}</script>
